import { CSSProperties, RefObject, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type StyleProps = CSSProperties & {
  '--height': CSSProperties['height'];
};

export function KalenderWoche({
  isCurrentWeek,
  index,
  startOfWeek,
  endOfWeek,
  gridRef,
}: {
  isCurrentWeek: boolean;
  index: number;
  startOfWeek: string;
  endOfWeek: string;
  gridRef: RefObject<HTMLDivElement>;
}) {
  const [height, setHeight] = useState(0);
  const { t } = useTranslation();
  const heightOfHeader = 60;

  useEffect(() => {
    if (gridRef.current) {
      setHeight(gridRef.current.offsetHeight);
    }
  }, [gridRef]);

  return (
    <div className="relative">
      <div
        className={`flex flex-col items-center justify-center  ${isCurrentWeek ? 'bg-primary-blue-B600 text-white' : 'bg-transparent'} rounded-md p-0.5`}>
        <div className="text-sm whitespace-nowrap">
          {t('general.date.calendarWeek')} {index + 1}
        </div>
        <div
          className={`hidden md:flex text-xs ${isCurrentWeek ? 'text-white' : 'text-neutrals-N700'}`}>
          {startOfWeek + ' – ' + endOfWeek}
        </div>
      </div>
      {isCurrentWeek && (
        <div className="absolute flex flex-col justify-center items-center w-full mt-1.5">
          <div className="h-1.5 w-1.5 bg-primary-blue-B600 rounded-full" />
          <div
            className="w-[1px] h-[var(--height)] bg-neutrals-N500"
            style={
              {
                '--height': height - heightOfHeader + 'px',
              } as StyleProps
            }
          />
        </div>
      )}
    </div>
  );
}
